export default __webpack_public_path__ + "static/media/CryptoTreasuryLogo.d4b3ce90.webp";